/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { customInstance } from '../../../../mutator/instance';
import type {
  FetchAllTransactionsForVirtualAccountParams,
  VirtualAccountTransactionResponse,
} from '../../models';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const fetchAllTransactionsForVirtualAccount = (
  params: FetchAllTransactionsForVirtualAccountParams,
  signal?: AbortSignal
) => {
  return customInstance<VirtualAccountTransactionResponse[]>({
    url: `/accounts/transactions`,
    method: 'GET',
    params,
    signal,
  });
};

export const getFetchAllTransactionsForVirtualAccountQueryKey = (
  params: FetchAllTransactionsForVirtualAccountParams
) => {
  return [`/accounts/transactions`, ...(params ? [params] : [])] as const;
};

export const getFetchAllTransactionsForVirtualAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchAllTransactionsForVirtualAccount>>,
  TError = unknown
>(
  params: FetchAllTransactionsForVirtualAccountParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof fetchAllTransactionsForVirtualAccount>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getFetchAllTransactionsForVirtualAccountQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchAllTransactionsForVirtualAccount>>
  > = ({ signal }) => fetchAllTransactionsForVirtualAccount(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchAllTransactionsForVirtualAccount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FetchAllTransactionsForVirtualAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchAllTransactionsForVirtualAccount>>
>;
export type FetchAllTransactionsForVirtualAccountQueryError = unknown;

export const useFetchAllTransactionsForVirtualAccount = <
  TData = Awaited<ReturnType<typeof fetchAllTransactionsForVirtualAccount>>,
  TError = unknown
>(
  params: FetchAllTransactionsForVirtualAccountParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof fetchAllTransactionsForVirtualAccount>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFetchAllTransactionsForVirtualAccountQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
